import apiConfig from './apiConfig'
import merge from 'lodash/merge'
import { getEnvConfig } from '@praxis/component-runtime-env'

let cachedConfigPromise = null

function tapConfig() {
  if (!cachedConfigPromise) {
    cachedConfigPromise = (async () => {
      const envConfig = await getEnvConfig(
        process.env.NODE_ENV === 'development'
          ? '/config.json'
          : '/app-environment',
      )
      return merge(apiConfig, envConfig)
    })()
  }
  return cachedConfigPromise
}

export default tapConfig
